import { UTILITY_PLANS_LISTING, UTILITY_STOCKS_LISTING, UTILITY_USERS_LISTING } from "../../helpers/url_helper"
import { baseApi } from "./index";

export const utilityApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllUsers: builder.query({
      query: () => {
        return UTILITY_USERS_LISTING
      },
      transformResponse: (response) => response.data,
    }),
    getAllStocks: builder.query({
      query: ({ search = "", orderBy = "created_at", order = "desc" }) => {
        let query = new URLSearchParams({
          search,
          orderBy,
          order
        });
        return `${UTILITY_STOCKS_LISTING}?${query.toString()}`
      },
      transformResponse: (response) => response.data,
    }),
    getAllPlans: builder.query({
      query: ({ visibility }) => {
        let query = new URLSearchParams({
          visibility
        })
        return `${UTILITY_PLANS_LISTING}?${query.toString()}`
      },
      transformResponse: (response) => response.data,
    }),
  }),
})

export const {
  useGetAllUsersQuery,
  useGetAllStocksQuery,
  useGetAllPlansQuery
} = utilityApi;